// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpandedRowCompetitorsOffer_wrapper__8oT5k"};